import './App.css';
import { MantineProvider } from '@mantine/core';
import theme from './theme';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import LoginPage from './pages/LoginPage';
import ClientsPage from './pages/ClientsPage.tsx';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import LogoutPage from './pages/LogoutPage';
import AppLayout from './components/AppLayout';
import { AuthProvider, useAuth } from "./contexts/AuthProvider";
import { LocaleProvider } from './contexts/LocaleProvider';
import ContactsPage from './pages/ContactsPage';
import CampaignPage from './pages/CampaignPage';
import ProductsPage from './pages/ProductsPage';
import TasksPage from './pages/TasksPage';
import ProtectedRoute from './components/ProtectedRoute';
import OpportunityPage from './pages/OpportunityPage';
import UsersPage from './pages/UsersPage.tsx';
import { NotificationsProvider } from './contexts/NotificationProvider';
import EnterprisePage from './pages/EnterprisePage';
import BalancePage from './pages/BalancePage';
import InvoicePage from './pages/InvoicePage';
import AdminAccessPage from './pages/AdminAccessPage';
import KpisPage from './pages/KpisPage';
import InventoryPage from './pages/InventoryPage';
import { PAGE_KEYS } from './utility/pageAccess';
import { useTranslation } from 'react-i18next';

function UnauthorizedMessage() {
  const { t } = useTranslation();
  return <div>{t('common.unauthorized')}</div>;
}

function AppRoutes() {
  const { user } = useAuth();

  return (
    <LocaleProvider userLocale={user?.locale}>
      <NotificationsProvider>
        <Routes>
                <Route path="/login" element={<LoginPage />} />
                <Route path="/logout" element={<LogoutPage />} />
                <Route path="/forgot-password" element={<ForgotPasswordPage />} />
                <Route path="/reset-password" element={<ResetPasswordPage />} />
                <Route element={<AppLayout />}>
                  <Route path="/clients" element={
                    <ProtectedRoute requiredRoles={["admin", "user"]} pageKey={PAGE_KEYS.clients}>
                      <ClientsPage />
                    </ProtectedRoute>} />
                  <Route path="/contacts" element={
                    <ProtectedRoute requiredRoles={["admin", "user"]} pageKey={PAGE_KEYS.contacts}>
                      <ContactsPage />
                    </ProtectedRoute>} />
                  <Route path="/campaigns" element={
                    <ProtectedRoute requiredRoles={["admin", "user"]} pageKey={PAGE_KEYS.campaigns}>
                      <CampaignPage />
                    </ProtectedRoute>} />
                  <Route path="/products" element={
                    <ProtectedRoute requiredRoles={["admin", "user"]} pageKey={PAGE_KEYS.products}>
                      <ProductsPage />
                    </ProtectedRoute>} />
                  <Route path="/inventory" element={
                    <ProtectedRoute requiredRoles={["admin", "user"]} pageKey={PAGE_KEYS.inventory}>
                      <InventoryPage />
                    </ProtectedRoute>} />
                  <Route path="/balance" element={
                    <ProtectedRoute requiredRoles={["admin", "user"]} pageKey={PAGE_KEYS.balance}>
                      <BalancePage />
                    </ProtectedRoute>} />
                  <Route path="/invoices" element={
                    <ProtectedRoute requiredRoles={["admin", "user"]} pageKey={PAGE_KEYS.invoices}>
                      <InvoicePage />
                    </ProtectedRoute>} />
                  <Route path="/tasks" element={
                    <ProtectedRoute requiredRoles={["admin", "user"]} pageKey={PAGE_KEYS.tasks}>
                        <TasksPage />
                    </ProtectedRoute>} />
                  <Route path="/opportunity" element={
                    <ProtectedRoute requiredRoles={["admin", "user"]} pageKey={PAGE_KEYS.opportunity}>
                      <OpportunityPage />
                    </ProtectedRoute>} />
                  <Route path="/kpis" element={
                    <ProtectedRoute requiredRoles={["admin", "user"]} pageKey={PAGE_KEYS.kpis}>
                      <KpisPage />
                    </ProtectedRoute>} />
                  <Route path="/users" element={
                    <ProtectedRoute requiredRoles={["admin"]}>
                      <UsersPage />
                    </ProtectedRoute>} />
                  <Route path="/enterprises" element={
                    // TODO: Alterar a role para uma chamada de "SuperAdmin"
                    <ProtectedRoute requiredRoles={["admin"]}>
                      <EnterprisePage />
                    </ProtectedRoute>} />
                  <Route path="/admin/access" element={
                    <ProtectedRoute requiredRoles={["admin"]}>
                      <AdminAccessPage />
                    </ProtectedRoute>} />
                  <Route path="/" element={
                    <ProtectedRoute requiredRoles={["admin", "user"]} pageKey={PAGE_KEYS.opportunity}>
                      <OpportunityPage />
                    </ProtectedRoute>} />
                  <Route path="/unauthorized" element={<UnauthorizedMessage />} />
                </Route>
                
                {/* Redireciona qualquer rota desconhecida para o login */}
                <Route path="*" element={<Navigate to="/login" replace />} />
              </Routes>
            </NotificationsProvider>
    </LocaleProvider>
  );
}

function App() {
  return (
      <MantineProvider theme={theme}>
        <Router>
          <AuthProvider>
            <AppRoutes />
          </AuthProvider>
        </Router>
      </MantineProvider>
  );
}

export default App;